import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Predictable from "./predictable/predictable";
import { generateRandomId } from "./predictable/utils";
import { words } from "./words";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import Document from "@tiptap/extension-document";
import Paragraph from "@tiptap/extension-paragraph";
import Text from "@tiptap/extension-text";
import Image from "@tiptap/extension-image";
import Dropcursor from "@tiptap/extension-dropcursor";
import { Extension } from "@tiptap/core";
import TextAlign from "@tiptap/extension-text-align";
import TTHighlight from "@tiptap/extension-highlight";
import TextStyle from "@tiptap/extension-text-style";
import FontFamily from "@tiptap/extension-font-family";
import FontSize from "./extensions/FontSize";
import Color from "./extensions/Color";
import TTLink from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import {
  FormatBold,
  InsertPhoto,
  FormatListBulleted,
  FormatItalic,
  FormatAlignCenter,
  FormatAlignLeft,
  FormatAlignRight,
  FormatListNumbered,
  Undo,
  Redo,
  FormatUnderlined,
  GridOn,
  Link,
  FormatColorText,
  LinkOff,
} from "@material-ui/icons";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import { TwitterPicker } from "react-color";
import "./CommentLetter.css";
import API from "@safecv/api";
import { TOKEN_SESSION_ATTRIBUTE_NAME } from "@safecv/shared/appConstant";
import comment_repo from "@safecv/assets/Images/comment_repo.svg";
import { fontValues, fontSizeValues } from "../../../shared/appConstant";
import _ from "lodash";
import { fetchSuggestions } from "@safecv/actions/postActions";
import toast from "@safecv/shared/toast";
import MESSAGE from "@safecv/shared/message";
import content_copy from "@safecv/assets/Images/content_copy.svg";
var predict;

const MenuBar = ({
  editor,
  setCommentRepo,
  planStatus,
  sendColorFlag,
  colorFlag,
}) => {
  const [currentFontSize, setCurrentFontSize] = useState("5");
  const [currentFont, setCurrrentFont] = useState("Inter");
  const [imageOpen, setimageOpen] = useState(false);
  const [linkOpen, setLinkOpen] = useState(false);
  const [ShowColorFlag, setShowColorFlag] = useState(false);
  const [CurrentColor, setCurrentColor] = useState("#000");
  const [isCommentRepoVisible, setCommentRepoVisibilty] = useState(false);

  const fontSizeref = useRef(null);
  const selectedFont = useRef(null);
  const imageUrlRef = useRef(null);
  const linkUrlRef = useRef(null);

  useEffect(() => {
    if (!colorFlag) {
      sendColorFlag(false);
      setShowColorFlag(false);
    }
  }, [colorFlag]);

  const fontSizeOptions = fontSizeValues.map((item, index) => {
    return <option key={index}>{item}</option>;
  });

  const fontOptions = fontValues.map((item, index) => {
    return <option key={index}>{item}</option>;
  });

  const changeFontSize = () => {
    setCurrentFontSize(fontSizeref.current.value);
    editor
      .chain()
      .focus()
      .setfontSize(fontSizeref.current.value + "px")
      .run();
  };

  const changeFont = () => {
    setCurrrentFont(selectedFont.current.value);
    editor.chain().focus().setFontFamily(selectedFont.current.value).run();
  };

  const addImage = () => {
    setimageOpen(true);
  };

  const addLink = () => {
    setLinkOpen(true);
  };

  const handleImageURL = () => {
    const imageURL = imageUrlRef.current.value;
    if (imageURL) {
      editor.chain().focus().setImage({ src: imageURL }).run();
    }
    setimageOpen(false);
  };
  const handleLinkURL = () => {
    const linkURL = linkUrlRef.current.value;
    if (linkURL) {
      editor.chain().focus().setLink({ href: linkURL }).run();
    }
    setLinkOpen(false);
  };

  const handleClose = () => {
    setimageOpen(false);
  };

  const handleLinkClose = () => {
    setLinkOpen(false);
  };

  const showColorPallete = (e) => {
    e.stopPropagation();
    sendColorFlag(!ShowColorFlag);
    setShowColorFlag(!ShowColorFlag);
  };

  const handleColorChange = (color) => {
    setCurrentColor(color);
    editor.chain().focus().setcolor(color.hex).run();
  };

  const handleCommentRepository = (e) => {
    setCommentRepoVisibilty(true);
    setCommentRepo(true);
  };

  if (!editor) {
    return null;
  }

  const execCommandOnElement = (el, commandName, value = null) => {
    if (typeof window.getSelection != "undefined") {
      // Non-IE case
      var sel = window.getSelection();

      // Save the current selection
      var savedRanges = [];
      for (var i = 0, len = sel.rangeCount; i < len; ++i) {
        savedRanges[i] = sel.getRangeAt(i).cloneRange();
      }

      // Temporarily enable designMode so that
      // document.execCommand() will work
      document.designMode = "on";

      // Select the element's content
      sel = window.getSelection();
      var range = document.createRange();
      range.selectNodeContents(el);
      sel.removeAllRanges();
      sel.addRange(range);

      // Execute the command
      document.execCommand(commandName, false, value)
        ? toast.success(MESSAGE.COPY_SUCCESS)
        : toast.error(MESSAGE.COPY_FAILURE);

      // Disable designMode
      document.designMode = "off";

      // Restore the previous selection
      sel = window.getSelection();
      sel.removeAllRanges();
      for (var i = 0, len = savedRanges.length; i < len; ++i) {
        sel.addRange(savedRanges[i]);
      }
    } else if (typeof document.body.createTextRange != "undefined") {
      // IE case
      var textRange = document.body.createTextRange();
      textRange.moveToElementText(el);
      textRange.execCommand(commandName, false, null);
    }
  };

  const selectAllContents = () => {
    editor.commands.selectAll();
    var fullEditorContent = document.getElementsByClassName("ProseMirror")[0];
    execCommandOnElement(fullEditorContent, "copy");
  };

  return (
    <>
      <div
        className={`${
          planStatus !== "Verify"
            ? "MenuContainer non-editable"
            : "MenuContainer editable"
        }`}
      >
        <div className="iconsHolder">
          <Tooltip title="Comment Repository" placement="top">
            <img
              src={comment_repo}
              className="comment_repo_icon"
              alt=""
              onClick={() => handleCommentRepository()}
            />
          </Tooltip>

          <select
            className="editorSelect"
            onChange={changeFontSize}
            ref={fontSizeref}
            value={currentFontSize}
          >
            {fontSizeOptions}
          </select>
          <select
            className="editorSelect"
            onChange={changeFont}
            ref={selectedFont}
            value={currentFont}
          >
            {fontOptions}
          </select>
          <Tooltip title="Bold" placement="top">
            <button onClick={() => editor.chain().focus().toggleBold().run()}>
              <FormatBold
                className={editor.isActive("bold") ? "is-active" : ""}
              />
            </button>
          </Tooltip>

          <Tooltip title="Italic" placement="top">
            <button
              onClick={() => editor.chain().focus().toggleItalic().run()}
              className={editor.isActive("italic") ? "is-active" : ""}
            >
              <FormatItalic
                className={editor.isActive("italic") ? "is-active" : ""}
              />
            </button>
          </Tooltip>
          <Tooltip title="Underline" placement="top">
            <button
              onClick={() => editor.chain().focus().toggleUnderline().run()}
              className={editor.isActive("underline") ? "is-active" : ""}
            >
              <FormatUnderlined
                className={editor.isActive("underline") ? "is-active" : ""}
              />
            </button>
          </Tooltip>
          <Tooltip title="Text Color" placement="top">
            <span id="textColor">
              <button onClick={showColorPallete}>
                <FormatColorText />
              </button>
              {ShowColorFlag && (
                <TwitterPicker
                  triangle="hide"
                  color={CurrentColor}
                  onChangeComplete={handleColorChange}
                />
              )}
            </span>
          </Tooltip>

          {/*Alignments*/}
          <Tooltip title="Center Align" placement="top">
            <button
              onClick={() =>
                editor.chain().focus().setTextAlign("center").run()
              }
              className={
                editor.isActive({ textAlign: "center" }) ? "is-active" : ""
              }
            >
              <FormatAlignCenter
                className={
                  editor.isActive({ textAlign: "center" }) ? "is-active" : ""
                }
              />
            </button>
          </Tooltip>
          <Tooltip title="Left Align" placement="top">
            <button
              onClick={() => editor.chain().focus().setTextAlign("left").run()}
              className={
                editor.isActive({ textAlign: "left" }) ? "is-active" : ""
              }
            >
              <FormatAlignLeft
                className={
                  editor.isActive({ textAlign: "left" }) ? "is-active" : ""
                }
              />
            </button>
          </Tooltip>
          <Tooltip title="Right Align" placement="top">
            <button
              onClick={() => editor.chain().focus().setTextAlign("right").run()}
              className={
                editor.isActive({ textAlign: "right" }) ? "is-active" : ""
              }
            >
              <FormatAlignRight
                className={
                  editor.isActive({ textAlign: "right" }) ? "is-active" : ""
                }
              />
            </button>
          </Tooltip>

          <Tooltip title="Add Image" placement="top">
            <button onClick={addImage}>
              <InsertPhoto />
            </button>
          </Tooltip>
          <Dialog
            open={imageOpen}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Image URL</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="url"
                label="URL"
                type="text"
                fullWidth
                inputRef={imageUrlRef}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleClose}
                color="primary"
                className="cancel_button"
              >
                Cancel
              </Button>
              <Button
                onClick={handleImageURL}
                color="primary"
                className="add_image_button"
              >
                Add Image
              </Button>
            </DialogActions>
          </Dialog>

          <Tooltip title="Add Link" placement="top">
            <button onClick={addLink}>
              <Link />
            </button>
          </Tooltip>

          <Dialog
            open={linkOpen}
            onClose={handleLinkClose}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Link</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="url"
                label="URL"
                type="text"
                fullWidth
                inputRef={linkUrlRef}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleLinkClose}
                color="primary"
                className="cancel_button"
              >
                Cancel
              </Button>
              <Button
                onClick={handleLinkURL}
                color="primary"
                className="add_image_button"
              >
                Add Link
              </Button>
            </DialogActions>
          </Dialog>
          <Tooltip title="Link Off" placement="top">
            <button onClick={() => editor.chain().focus().unsetLink().run()}>
              <LinkOff />
            </button>
          </Tooltip>

          <Tooltip title="Bulletin List" placement="top">
            <button
              onClick={() => editor.chain().focus().toggleBulletList().run()}
              className={editor.isActive("bulletList") ? "is-active" : ""}
            >
              <FormatListBulleted
                className={editor.isActive("bulletList") ? "is-active" : ""}
              />
            </button>
          </Tooltip>
          <Tooltip title="Ordered List" placement="top">
            <button
              onClick={() => editor.chain().focus().toggleOrderedList().run()}
              className={editor.isActive("orderedList") ? "is-active" : ""}
            >
              <FormatListNumbered
                className={editor.isActive("orderedList") ? "is-active" : ""}
              />
            </button>
          </Tooltip>
          <Tooltip title="Highlight" placement="top">
            <button
              onClick={() => editor.chain().focus().toggleHighlight().run()}
              className={editor.isActive("highlight") ? "is-active" : ""}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className={
                  editor.isActive("highlight") ? "is-active" : "not-active"
                }
              >
                <path d="M 12.078125 6.480469 L 7.039062 10.558594 L 10.078125 13.679688 C 11.679688 15.359375 13.359375 16.558594 13.679688 16.320312 C 14.800781 15.679688 21.601562 6.558594 21.601562 5.761719 C 21.601562 4.878906 18.878906 2.398438 17.921875 2.398438 C 17.519531 2.480469 14.878906 4.238281 12.078125 6.480469 Z M 5.039062 14.71875 C 5.199219 16.238281 5.519531 17.761719 5.761719 18.078125 C 6.558594 18.878906 12 19.28125 12 18.558594 C 12 17.761719 6.160156 12 5.441406 12 C 5.121094 12 4.960938 13.199219 5.039062 14.71875 Z M 2.800781 19.199219 C 2.558594 19.601562 2.878906 20.238281 3.601562 20.480469 C 5.359375 21.199219 5.921875 20.398438 4.480469 19.28125 C 3.679688 18.640625 3.199219 18.558594 2.800781 19.199219 Z M 2.800781 19.199219 " />
              </svg>
            </button>
          </Tooltip>
          <Tooltip title="Undo" placement="top">
            <button onClick={() => editor.chain().focus().undo().run()}>
              <Undo />
            </button>
          </Tooltip>
          <Tooltip title="Redo" placement="top">
            <button onClick={() => editor.chain().focus().redo().run()}>
              <Redo />
            </button>
          </Tooltip>
          <Tooltip title="Insert table" placement="top">
            <button
              className="check_disable"
              disabled={planStatus !== "Verify" ? true : false}
              onClick={() =>
                editor
                  .chain()
                  .focus()
                  .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
                  .run()
              }
            >
              <GridOn />
            </button>
          </Tooltip>
          <Tooltip title="Select all & copy" placement="top">
            <button onClick={selectAllContents}>
              <img alt="" src={content_copy} />
            </button>
          </Tooltip>
          <div
            className={"table-options"}
            id={!editor.can().addColumnBefore() ? "hidden" : "shown"}
          >
            <br />
            <button
              className="table-option-button"
              onClick={() => editor.chain().focus().addColumnBefore().run()}
              disabled={!editor.can().addColumnBefore()}
            >
              Insert Column Before
            </button>
            <button
              className="table-option-button"
              onClick={() => editor.chain().focus().addColumnAfter().run()}
              disabled={!editor.can().addColumnAfter()}
            >
              Insert Column After
            </button>
            <button
              className="table-option-button"
              onClick={() => editor.chain().focus().deleteColumn().run()}
              disabled={!editor.can().deleteColumn()}
            >
              Delete Column
            </button>
            <button
              className="table-option-button"
              onClick={() => editor.chain().focus().addRowBefore().run()}
              disabled={!editor.can().addRowBefore()}
            >
              Insert Row Before
            </button>
            <button
              className="table-option-button"
              onClick={() => editor.chain().focus().addRowAfter().run()}
              disabled={!editor.can().addRowAfter()}
            >
              Insert Row After
            </button>
            <button
              className="table-option-button"
              onClick={() => editor.chain().focus().deleteRow().run()}
              disabled={!editor.can().deleteRow()}
            >
              Delete Row
            </button>
            <button
              className="table-option-button"
              onClick={() => editor.chain().focus().deleteTable().run()}
              disabled={!editor.can().deleteTable()}
            >
              Delete Table
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const CommentLetter = (props) => {
  const {
    jobId,
    isDocumentSelected,
    setcurrentData,
    setCommentRepo,
    planStatus,
    fetchSuggestions,
    suggesstions,
  } = props;
  //props received from parent component can be used

  const [instance, setInstance] = useState(null);
  const [colorFlag, sendColorFlag] = React.useState(false);
  const [predictableContainerId, setPredictableContainerId] = useState(
    `${generateRandomId()}-${generateRandomId()}`
  );
  const [editorId, setEditorId] = useState(
    `${generateRandomId()}-${generateRandomId()}`
  );
  const [font, setFont] = useState("Lato, serif!important");
  const [fontSize, setFontSize] = useState("14px!important");
  const [letterSpacing, letLetterSpacing] = useState("0!important");
  const [suggestions, setSuggestions] = useState(words);
  const editorRef = useRef(null);

  const preventTabDefault = (e) => {
    const { key } = e;

    if (key && key === "Tab") {
      e.preventDefault();
    }
    /*
    // TODO: Use control key + up/down to cycle through multiple suggestions.
    if ( e.ctrlKey && ( key === 'ArrowUp' || key === 'ArrowDown' ) ) {
        e.preventDefault();
    }

*/
  };

  useEffect(() => {
    if (suggesstions && suggesstions.length !== 0) {
      setSuggestions([suggesstions]);
      predict.promptData = [suggesstions];
    }
  }, [suggesstions]);

  /* Extensions*/

  const CustomTableCell = TableCell.extend({
    addAttributes() {
      return {
        // extend the existing attributes …
        ...this.parent?.(),

        // and add a new one …
        backgroundColor: {
          default: null,
          parseHTML: (element) => {
            return {
              backgroundColor: element.getAttribute("data-background-color"),
            };
          },
          renderHTML: (attributes) => {
            return {
              "data-background-color": attributes.backgroundColor,
              style: `background-color: ${attributes.backgroundColor}`,
            };
          },
        },
      };
    },
  });

  const debounceValue = useRef(
    _.debounce((editorHTML) => {
      setcurrentData(editorHTML);
    }, 5000)
  );

  const CustomExtension = Extension.create({
    onUpdate({ editor }) {
      debounceValue.current(editor.getHTML());
    },
  });

  /* Editor config*/

  const editor = useEditor({
    props: setCommentRepo,
    extensions: [
      StarterKit,
      Table.configure({
        //resizable: true,
      }),
      TableRow,
      TableHeader,
      TableCell,
      CustomTableCell,
      Document,
      Paragraph,
      Text,
      Image,
      Dropcursor,
      CustomExtension,
      TextStyle,
      FontFamily,
      FontSize,
      Color,
      Underline,
      TTLink,
      TextAlign.configure({
        types: ["heading", "paragraph"],
      }),
      TTHighlight,
    ],
    editable: props.planStatus === "Verify" ? true : false,
    content:
      props.data !== null
        ? props.data
        : `
    <p>Some issues in extracting content. You can manually copy the content from the DOC file and edit it further<p>`,
  });

  /*Menu bar config*/

  useEffect(() => {
    if (instance) {
      instance.loadDocument(
        API.DATATABLE_DOWNLOAD + "plan/" + jobId + "?download=aicomment",
        {
          filename: "pdffile.docx",
          customHeaders: {
            Authorization: localStorage.getItem(TOKEN_SESSION_ATTRIBUTE_NAME),
          },
        }
      );
    }
  }, [instance]);

  const predicatableLogic = (dataSource) => {
    const editorContent = document.getElementById(editorId);
    editorContent.addEventListener("keydown", preventTabDefault);
    editorContent.addEventListener("keyup", (e) => {
      const predictableContainer = document.getElementById(
        predictableContainerId
      );
      predictableContainer.style.display = "none";
      if (
        predictableContainer &&
        e.key !== "Backspace" &&
        e.key !== "Enter" &&
        // Only check for suggested phrases if the user is typing at the end of the document.
        (!isCaretAtEnd(editorContent) || isCaretAtEnd(editorContent))
      ) {
        const incompleteText = document.getSelection().anchorNode;
        if (incompleteText) {
          const currentCoordinates = getLastWordCoordinates();
          // We create the visual effect of a placeholder element by overlaying the
          // suggestion container at the exact position of the incomplete text.
          predictableContainer.style.top = `${Math.round(
            currentCoordinates.top
          )}px`;
          predictableContainer.style.left = `${currentCoordinates.left}px`;
          predictableContainer.style.display = "inline";
        }
      }
    });
    editorContent.style.cssText = `
        font-family: ${font};
        font-size: ${fontSize};
        letter-spacing: ${letterSpacing};
        line-height: 1.7rem;
        outline: none;
    `;

    predict = new Predictable({
      predictableContainerId: predictableContainerId,
      editorId: editorId,
      data: dataSource,
      editor: editorContent,
      sensitivity: 3,
      predictableContainer: {
        container: (source) => {
          source.setAttribute("id", predictableContainerId);
          source.style.cssText = `
                    display: none;
                    font-family: ${font};
                    font-size: ${fontSize};
                    letter-spacing: ${letterSpacing};
                    -webkit-user-modify: read-only;
                    user-select: none;
                    cursor: text;
                    position: fixed;
                    text-overflow: ellipsis;
                    white-space: wrap;
                    overflow: hidden;
                    z-index: 99999;
                    color: #757575;
                    opacity: 0.7;
                    overflow: hidden;
                    width:auto;
                `;
        },
      },
      suggestionText: {
        content: ({ match }, source) => {
          source.textContent = match;
        },
      },
      context: {
        getData: () => {
          getLastWordCoordinates();
          return getLastWord();
        },
      },
      onTabPress: () => {
        const incompleteText = document.getSelection().anchorNode,
          range = document.createRange();

        range.selectNodeContents(incompleteText);

        let _incompleteText = incompleteText;

        if (incompleteText.nodeType === 3) {
          _incompleteText = incompleteText.data;
        } else {
          _incompleteText = incompleteText.textContent;
        }

        let autocompleteText = document.querySelector(
          ".predictable__suggestion"
        ).firstChild.data;
        autocompleteText = autocompleteText.replace(_incompleteText, "");

        insertTextAtCursor(editorRef, autocompleteText);
      },
    });
  };

  useEffect(() => {
    predicatableLogic(suggestions);
  }, []);

  const getLastWordCoordinates = () => {
    const selection = window.getSelection(),
      anchorNode = selection.anchorNode,
      previousRange = selection.getRangeAt(0),
      lastWordOffset = getLastWordOffset(getLastWord()),
      range = document.createRange();
    range.setStart(anchorNode, lastWordOffset);
    range.setEnd(anchorNode, lastWordOffset);
    range.collapse(false);

    // Create a `shadowNode`, which is an invisible DOM node that allows the coordinates of the following
    // word to be calculated.
    const shadowNode = document.createElement("span");
    shadowNode.id = generateRandomId();
    shadowNode.appendChild(document.createTextNode(""));
    range.insertNode(shadowNode);
    selection.removeAllRanges();
    selection.addRange(previousRange);

    const { top, left } = shadowNode.getBoundingClientRect(),
      parentNode = shadowNode.parentElement;

    // Rejoins the text nodes which have been split by inserting the shadow node.
    parentNode.normalize();
    parentNode.removeChild(shadowNode);
    return { top, left };
  };

  const getLastWord = () => {
    const selectedElement = window.getSelection().anchorNode;
    if (selectedElement && selectedElement.data) return selectedElement.data;
  };

  const getLastWordOffset = (text) => {
    if (text) {
      const words = text.split(" ");
      const range = getLastWord();
      const lastWordOfRange = words[words.length - 1].trim();

      if (lastWordOfRange.length === 0) {
        // If sentence is continued, Ignore previous sentence and take the last 3 words
        if (words.length > 5) {
          let snippedWord = words.slice(Math.max(words.length - 3, 1));
          fetchSuggestions(snippedWord.join(" "));
        } else {
          fetchSuggestions(text);
        }
      }

      // Returns the offset position of the last word.
      return range.length - lastWordOfRange.length;
    }

    return 0;
  };

  const isCaretAtEnd = (element) => {
    let caretEndPosition = false,
      selectionRange,
      temporaryRange;

    if (window.getSelection) {
      const selection = window.getSelection();
      if (selection && selection.rangeCount) {
        selectionRange = selection.getRangeAt(0);
        temporaryRange = selectionRange.cloneRange();

        temporaryRange.selectNodeContents(element);
        temporaryRange.setEnd(
          selectionRange.startContainer,
          selectionRange.startOffset
        );
        temporaryRange.selectNodeContents(element);
        temporaryRange.setStart(
          selectionRange.endContainer,
          selectionRange.endOffset
        );
        caretEndPosition = temporaryRange.toString() === "";
      }
    }

    return caretEndPosition;
  };

  const insertTextAtCursor = (editor, text) => {
    let selection, range;

    if (window.getSelection) {
      selection = window.getSelection();
      if (selection && selection.getRangeAt && selection.rangeCount) {
        range = selection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(document.createTextNode(text));
      }
    }
    const predictableContainer = document.getElementById(
      predictableContainerId
    );
    predictableContainer.style.display = "none";
    placeCaretAtEnd();
  };

  const placeCaretAtEnd = () => {
    if (
      typeof window.getSelection !== "undefined" &&
      typeof document.createRange !== "undefined"
    ) {
      const range = document.createRange();
      range.collapse(false);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
  };

  const docClick = () => {
    sendColorFlag(false);
  };

  const removeElements = (elms) => elms.forEach((el) => el.remove());

  const listenScroll = (e) => {
    const predictableContainer = document.getElementById(
      predictableContainerId
    );
    if (predictableContainer.style.display === "inline") {
      removeElements(document.querySelectorAll(".predictable__suggestion"));
    }
  };

  return (
    <div
      className={`comment-letter-container 
       ${
         isDocumentSelected ? "pdf-visibility-enable" : "pdf-visibility-disable"
       }`}
      onClick={docClick}
    >
      <MenuBar
        editor={editor}
        setCommentRepo={setCommentRepo}
        planStatus={planStatus}
        sendColorFlag={sendColorFlag}
        colorFlag={colorFlag}
      />
      <div
        className={`${planStatus !== "Verify" ? "non-editable" : "editable"} ${
          colorFlag ? "open-color-palette" : "close-color-palette"
        }`}
      >
        <EditorContent
          editor={editor}
          ref={editorRef}
          data-id="editor"
          id={editorId}
          onScroll={listenScroll}
        />
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => ({
  suggesstions: state.verification.sugesstions,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    fetchSuggestions: (data) => {
      dispatch(fetchSuggestions(data));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(CommentLetter);
